import { z } from 'zod';
export const upsertTimeoutConfigSchema = z.object({
    id: z.number().optional(),
    name: z.string().min(1),
    first_turn_timeout: z.number().positive(),
    other_turns_timeout: z.number().positive(),
    confirmation_timeout: z.number().positive(),
    agentId: z.string(),
});
